import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useDarkMode } from '../contexts/DarkModeContext';

interface DarkModeToggleProps {
  className?: string;
  iconClassName?: string;
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({
  className = 'p-1.5',
  iconClassName = 'h-4 w-4'
}) => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={() => {
        toggleDarkMode();
      }}
      className={`${className} bg-transparent flex items-center justify-center text-gray-700 dark:text-dark-text hover:text-accent-500 dark:hover:text-accent-300 transition-colors duration-200 focus:outline-none`}
      aria-label={isDarkMode ? 'تفعيل الوضع النهاري' : 'تفعيل الوضع الليلي'}
    >
      {isDarkMode ? <Sun className={iconClassName} /> : <Moon className={iconClassName} />}
    </button>
  );
};

export default DarkModeToggle;
